<template>
  <div class="page-wrapper">
    <header class="header">
      <!-- End .header-top -->
      <div class="header-middle sticky-header clear-menu-header">
        <div class="container">
          <div class="header-left">
            <button class="mobile-menu-toggler" type="button">
              <i class="icon-menu"></i>
            </button>
            <a href="/" class="logo">
              <img src="/assets/images/logo.png" alt="Eurosan Logo" />
            </a>
          </div>
          <!-- End .header-left -->

          <div class="header-right d-none">
            <div class="header-dropdown">
              <a href="#">ENG</a>
              <div class="header-menu">
                <ul>
                  <li><a href="#">ENGLISH</a></li>
                  <li><a href="#">CROATIAN</a></li>
                </ul>
              </div>
              <!-- End .header-menu -->
            </div>
            <!-- End .header-dropown -->
          </div>
          <!-- End .header-right -->
        </div>
        <!-- End .container -->
      </div>
      <!-- End .header-middle -->
    </header>
    <!-- End .header -->

    <main class="main home">
      <router-view />
    </main>
    <!-- End .main -->
    <Footer />
    <Loader />
    <!-- End .footer -->
  </div>
  <!-- End .page-wrapper -->
</template>

<script>
import Footer from '@/components/Footer/Footer.vue';
import Loader from '@/components/shared/Loader.vue';

export default {
  name: 'AuthApp',
  components: {
    Footer,
    Loader,
  },
};
</script>
